import React from 'react';

export const serviceCashPickUpConfig = [
  {
    path: '/service-cash-pick-up',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/service-cash-pick-up/rincian-order',
    component: React.lazy(() => import('./rincian-pecahan/rincian-pecahan')),
  },
  {
    path: '/service-cash-pick-up/overview-rincian-order',
    component: React.lazy(() =>
      import('./overviewRincianPecahan/overviewRincianPecahan'),
    ),
  },
  {
    path: '/service-cash-pick-up/perbaikan-transaksi',
    component: React.lazy(() => import('./rincianPerbaikan/rincianPerbaikan')),
  },
  {
    path: '/service-cash-pick-up/overview-rincian-order-completed',
    component: React.lazy(() =>
      import('./overviewRincianCompleted/overviewRincianCompleted'),
    ),
  },
  {
    path: '/service-cash-pick-up/overview-rincian-order-perbaikan',
    component: React.lazy(() =>
      import('./overviewRincianPerbaikan/overviewRincianPerbaikan'),
    ),
  },
  // {
  //   path: '/order-cash-pick-up/edit',
  //   component: React.lazy(() => import('./edit/edit')),
  // },
  {
    path: '/service-cash-pick-up/view',
    component: React.lazy(() => import('./view/view')),
  },
  {
    path: '/service-cash-pick-up/konfirmasi-perbaikan-no-seal',
    component: React.lazy(() =>
      import('./perbaikanNoSealCashPickUp/perbaikanNoSealCashPickUp'),
    ),
  },
];
